import React from 'react'
import Header from "../Header/Header"
import Banner from '../Banner/Banner';
import HomePageCard from '../HomePageCard/HomePageCard'
import Floink from '../Floink/Floink'
import Services from '../Services/Services'
import Footer from '../Footer/Footer'
 
function Home() {
    return (
        <div className='main-bg'>
            <Header />
            <Banner />
            <HomePageCard />
            <Floink />
            <Services />
            <Footer />
        </div>
    );
}
export default Home;